import {Component, Injector} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

import {QuestionPage} from '../../components/question-page/question-page';
import { NavService } from 'shared/nav/nav.service';

@Component({
  selector: 'message-page',
  templateUrl: 'message-page.html',
  styleUrls: ['message-page.scss'],
  host: { '[class]': '"ion-page can-go-back"' },
})
export class MessagePage extends QuestionPage {

  constructor(
    private translateService: TranslateService,
    private injector: Injector,
    private sanitizer: DomSanitizer,
    public navService: NavService,
  ) {
    super(injector, navService);
  }

  public onNextClick(): void {
    this.answerSelected.emit('');
  }
}
